import { createAction } from 'redux-actions';
import Promise from 'bluebird';
import _ from 'lodash';
import reusableDataSourceConfigs from '../config/dataSourceConfigs';
import providers from '../provider';

let latestRequests = {};

export default createAction('LOAD_DATA_SOURCES', async ({ dataSourceConfigs, excludeParams, limit = {}, offset = {}, country, language, search, path, routeParams, isBackNavigation, storeState }) => {
  if (isBackNavigation && storeState.dataSources.previousDataSources) return;

  const expandedDataSourceConfigs = _.mapValues(dataSourceConfigs, dataSourceConfig =>
    typeof dataSourceConfig === 'string' ? _.get(reusableDataSourceConfigs, dataSourceConfig) : dataSourceConfig
  );

  latestRequests = {
    ...latestRequests,
    ...expandedDataSourceConfigs,
  };

  let dataSources = _.mapValues(expandedDataSourceConfigs, (dataSourceConfig, dataSourceName) => {
    if (_.isFunction(dataSourceConfig)) return dataSourceConfig();

    return providers[dataSourceConfig.provider]({
      config: dataSourceConfig.config,
      excludeParams,
      limit: limit[dataSourceName],
      offset: offset[dataSourceName],
      routeParams,
      country,
      search,
      language,
      path,
      storeState,
    });
  });

  dataSources = await Promise.props(dataSources);

  // throw away all results except for the results of the latest request
  return _.pickBy(dataSources, (value, dataSourceName) =>
    _.isEqual(expandedDataSourceConfigs[dataSourceName], latestRequests[dataSourceName])
  );
});



// WEBPACK FOOTER //
// ./src/action/loadDataSources.js